import { render } from "./BaseProductOverlay.vue?vue&type=template&id=dd6706ec&scoped=true"
import script from "./BaseProductOverlay.vue?vue&type=script&lang=js"
export * from "./BaseProductOverlay.vue?vue&type=script&lang=js"

import "./BaseProductOverlay.vue?vue&type=style&index=0&id=dd6706ec&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6706ec"]])

export default __exports__